export class Organisation {
  OrgName: string;
  OrgCode: string;
  OrgId: number;
  ActivationKey: string;
  IsActive: boolean;
  RegData: string;
  OrgUnits: OrganisationUnit[];

}
export class OrganisationUnit {
  UnitId: number;
  UnitName: string;
  IsActive: boolean;
  IsSelected: boolean;
}

export interface IOrganisation {
  OrgName: string;
  OrgCode: string;
  OrgId: number;
  ActivationKey: string;
  IsActive: boolean;
  RegData: string;
  OrgUnits: OrganisationUnit[]
}
export interface IOrganisationUnit {
  UnitId: number;
  UnitName: string;
  IsActive: boolean;
  IsSelected: boolean;
}

export class OrganisationParser {
  OrgName: string;
  OrgCode: string;
  OrgId: number;
  ActivationKey: string;
  IsActive: boolean;
  RegData: string;
  OrgUnits: OrganisationUnit[];

  constructor(jsonStr: string) {
    let jsonObj = JSON.parse(jsonStr);
    for (let prop in jsonObj) {
      this[prop] = jsonObj[prop];
    }
  }
}
